exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-iframe {\n  max-width: 100%;\n  overflow-x: auto;\n}\n.uu5-bricks-iframe iframe {\n  height: 0;\n  width: 100%;\n  margin: 0;\n  box-sizing: border-box;\n  border: none;\n  transition: height 1s ease-out;\n}\n.uu5-bricks-iframe-inline {\n  display: inline-block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/iframe.less
// module id = 219
// module chunks = 0